import { Layout, Text } from '@loadsmart/miranda-react'

import { type Stop, hasAddress, hasDate } from 'core/domain/Stop'
import { formatAddress, formatDateAndTime, formatLocation } from 'core/presenters/stopPresenter'

export type LoadStopAddressProps = {
  stop: Stop
}

export function LoadStopAddress({ stop }: LoadStopAddressProps) {
  return (
    <Layout.Stack gap="spacing-0-5">
      {hasAddress(stop) && <Text>{formatAddress(stop)}</Text>}
      <Text variant="heading-md-bold">{formatLocation(stop)}</Text>
      {hasDate(stop) && <Text>{formatDateAndTime(stop)}</Text>}
    </Layout.Stack>
  )
}
